import { createFileRoute } from '@tanstack/react-router'

import { AccountDelinquencyScreen } from './-components/account-delinquency-screen.tsx'

export const Route = createFileRoute('/collections/account-delinquency')({
  component: AccountDelinquencyScreen
})
